import React from 'react';

import OsmMap from './OsmMap';
import MapBox from './MapBox';

const mapType = import.meta.env.VITE_MAP;

export const OSM_MAP = 'osm';
export const MAPBOX_MAP = 'mapbox';

const Map = (props) => {
  if (mapType === OSM_MAP) {
    return <OsmMap {...props} />;
  }

  return <MapBox {...props} />;
};

export default Map;
